// DEPENDENCIES ---------------------------------------------------------------- //

import React from 'react';

import uberLogo from '@assets/images/uber.svg';
import lyftLogo from '@assets/images/lyft.svg';

// TYPES ---------------------------------------------------------------- //

interface GuestRideProviderMarkProps {
  provider: string | null | undefined;
}

// COMPONENT ---------------------------------------------------------------- //

const GuestRideProviderMark: React.FC<GuestRideProviderMarkProps> = ({ provider }) => {
  if (!provider) return null;
  const lp = provider.toLowerCase();

  let src: string;
  let label: string;
  let height: number;

  if (lp.includes('uber')) {
    src = uberLogo;
    label = 'Uber';
    height = 14;
  } else if (lp.includes('lyft')) {
    src = lyftLogo;
    label = 'Lyft';
    height = 18;
  } else {
    return null;
  }

  return (
    <img
      src={src}
      alt={label}
      style={{ height, width: 'auto', verticalAlign: 'middle' }}
    />
  );
};

// EXPORT ---------------------------------------------------------------- //

export default GuestRideProviderMark;
